var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"gmp-page gmp-page--no-newsletter"},[_c('WIN_subpagehero'),_c('WIN_two_column_text'),_c('WIN_two_column_fullbleed')],1)}
var staticRenderFns = []

export { render, staticRenderFns }